import React, { useState } from "react";
import styled from "styled-components";
import "./App.css";

const Form = styled.form`
  margin: 8% auto;
  box-shadow: 1.8px 2.4px 5px 0 rgba(0, 0, 0, 0.3);
  border-top: solid 6px #fad312;
  width: 645px;
  padding: 64px 36px;
`;
const FormHeader = styled.div``;
const FormTitle = styled.div`
  font-size: 36px;
  font-weight: bold;
`;
const FormDesc = styled.div`
  font-size: 14px;
  margin-top: 24px;
  line-height: 1.8em;
`;
const FormNotice = styled.div`
  font-size: 16px;
  color: #e74149;
  margin-top: 24px;
`;
const InputBlock = styled.div`
  margin-top: 36px;
`;
const InputTitle = styled.div`
  font-size: 20px;
`;
const InputContent = styled.input`
  border: solid 1px #d0d0d0;
  margin-top: 18px;
  padding: 8px;
`;
const InputAdvice = styled.div`
  font-size: 14px;
  margin-top: 24px;
`;
const InputOption = styled.div`
  margin-top: 36px;
  margin-bottom: 20px;
`;
const OptionGroup = styled.label`
  margin-top: 18px;
  display: block;
`;
const Option = styled.input`
  margin-right: 10px;
`;
const SubmitButton = styled.button`
  padding: 13px 31px 13px 32px;
  border-radius: 3px;
  background-color: #fad312;
  margin-top: 68px;
  border: none;
  cursor: pointer;
`;
const Footer = styled.div`
  border-top: solid 6px #fad312;
  padding: 26px 21px;
  background: #000000;
  color: #999999;
  text-align: center;
`;
const ErrorText = styled.div`
  color: red;
  position: absoulte;
`;
const RequiredTag = styled.span`
  content: "*";
  color: #e74149;
`;
export default function App() {
  const [res, setRes] = useState({
    nickname: "",
    email: "",
    phone: "",
    type: "",
    referal: "",
    other: "",
    hasEmpty: false,
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!res["nickname"] || !res["email"] || !res["phone"] || !res["referal"]) {
      setRes({
        ...res,
        hasEmpty: true,
      });
      return;
    }
    alert("提交成功！");
  };
  const handleInputChange = (e) => {
    setRes({ ...res, [e.target.name]: e.target.value });
  };

  return (
    <div className="App">
      <Form onSubmit={handleSubmit}>
        <FormHeader>
          <FormTitle>新拖延運動報名表單</FormTitle>
          <FormDesc>
            活動日期：2020/12/10 ~ 2020/12/11 <br />
            活動地點：台北市大安區新生南路二段1號
          </FormDesc>
          <FormNotice>* 必填</FormNotice>
        </FormHeader>
        <InputBlock>
          <InputTitle>
            暱稱<RequiredTag>*</RequiredTag>
          </InputTitle>
          <InputContent
            name="nickname"
            type="text"
            placeholder="您的回答"
            onChange={handleInputChange}
            value={res["nickname"]}
          ></InputContent>
          {!res["hasEmpty"] ||
            (!res["nickname"] && <ErrorText>此欄為必填</ErrorText>)}
        </InputBlock>
        <InputBlock>
          <InputTitle>
            電子郵件<RequiredTag>*</RequiredTag>
          </InputTitle>
          <InputContent
            name="email"
            type="text"
            placeholder="您的電子郵件"
            onChange={handleInputChange}
            value={res["email"]}
          ></InputContent>
          {!res["hasEmpty"] ||
            (!res["email"] && <ErrorText>此欄為必填</ErrorText>)}
        </InputBlock>
        <InputBlock>
          <InputTitle>
            手機號碼<RequiredTag>*</RequiredTag>
          </InputTitle>
          <InputContent
            name="phone"
            type="text"
            placeholder="您的手機號碼"
            onChange={handleInputChange}
            value={res["phone"]}
          ></InputContent>
          {!res["hasEmpty"] ||
            (!res["phone"] && <ErrorText>此欄為必填</ErrorText>)}
        </InputBlock>
        <InputOption>
          <InputTitle>
            報名類型<RequiredTag>*</RequiredTag>
          </InputTitle>
          <OptionGroup>
            <Option
              name="type"
              type="radio"
              value="1"
              onChange={handleInputChange}
            />
            躺在床上用想像力實作
          </OptionGroup>
          <OptionGroup>
            <Option
              name="type"
              type="radio"
              value="2"
              onChange={handleInputChange}
            />
            趴在地上滑手機找現成的
          </OptionGroup>
        </InputOption>
        {!res["hasEmpty"] ||
          (!res["type"] && <ErrorText>此欄為必填</ErrorText>)}
        <InputBlock>
          <InputTitle>
            怎麼知道這個活動的？<RequiredTag>*</RequiredTag>
          </InputTitle>
          <InputContent
            name="referal"
            type="text"
            placeholder="您的回答"
            onChange={handleInputChange}
            value={res["referal"]}
          ></InputContent>
          {!res["hasEmpty"] ||
            (!res["referal"] && <ErrorText>此欄為必填</ErrorText>)}
        </InputBlock>
        <InputBlock>
          <InputTitle>其他</InputTitle>
          <InputAdvice>對活動的一些建議</InputAdvice>
          <InputContent
            name="other"
            type="text"
            placeholder="您的回答"
            onChange={handleInputChange}
            value={res["other"]}
          ></InputContent>
        </InputBlock>
        <SubmitButton type="submit">提交</SubmitButton>
        <FormDesc>請勿透過表單送出您的密碼。</FormDesc>
      </Form>
      <Footer>© 2020 © Copyright. All rights Reserved.</Footer>
    </div>
  );
}
